import type { JSX } from 'react';

import { Link } from '@change-corgi/design-system-legacy/components/actions';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { PetitionDetails } from 'src/app/pages/petitionGamma/details/shared/types';

import { useUserProfileUrl } from '../../../../../../hooks/userProfileUrl';

export function UserLink({ user }: { user: PetitionDetails['user'] }): JSX.Element {
	const { data, actions } = useUserProfileUrl();
	const isSunriseThemeEnabled = useIsSunriseTheme();

	if (data.isAnonymous) {
		return (
			<Text fontWeight="bold" color="typography-primary">
				{user.displayName}
			</Text>
		);
	}

	return (
		<Link
			color="typography-primary"
			data-testid="user-profile-page-link"
			data-qa="user-profile-page-link"
			onClick={actions.onUserNameLinkClick}
			sx={{
				...(isSunriseThemeEnabled && {
					fontSize: '18px',
					textDecorationColor: 'sunrise.semantic.typography.weak',
				}),
			}}
			to={data.urlLink}
		>
			{user.displayName}
		</Link>
	);
}
